/** When your routing table is too long, you can split it into small modules**/
/* Layout */
import Layout from '@/layout'

/* Router Modules */
const ideaRouter = {
  path: '/idea',
  component: Layout,
  name: 'idea',
  redirect: '/idea',
  hidden: false,
  meta: {
    title: '意见单'
  },
  children: [
    {
      path: '/idea',
      component: () => import('@/views/idea/index'),
      name: 'idea',
      meta: { title: '意见单', affix: true, projectId: 100 }
    }
  ]
}

export default ideaRouter